module.exports = __webpack_public_path__ + "static/media/see2.144a9e54.jpg";